import { axiosGet } from './axiosGet';
import { devError } from './devLog';

export const getNominationFormData = async (nominationData) => {
  try {
    const response = await axiosGet('get-nomination-form-data', {
      data: nominationData,
    });

    if (response?.status === 200 && response?.data) {
      return response.data;
    }

    if (response?.status !== 200) {
      devError(`API returned status: ${response?.status}`);
      return null;
    }

    return null;
  } catch (error) {
    devError('Error fetching data:', error);
    throw error;
  }
};
